import * as React from "react";
import { WizardCarPWAViewProps } from "./typings";
import { observer } from "mobx-react";
import { LobTitle } from "src/components/shared/LobTitle/LobTitle";
import {
  UitkExperimentalButtonTabs,
  UitkTab,
  UitkTabsType,
  UitkTabAnchorType,
} from "uitk-react-experimental-button-tabs";
import { CarsFormView } from "./components/CarsFormView";
import { GroundTransportPWAView } from "./components/GroundTransportPWA/GroundTransportPWAView";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "./components/l10n";
import { LobSubtitle } from "src/components/shared/LobSubtitle/LobSubtitle";
import { carSubLOBs } from "src/stores/wizard/state/typings";

export const WizardCarPWAView: React.FunctionComponent<WizardCarPWAViewProps> = observer(
  ({
    context,
    flexComponent,
    isAARPChecked,
    isDriverAgeInRange,
    isDiffDropOff,
    onAARPChange,
    onDifferentDropOffSelected,
    onDriverAgeInRange,
    onTabOptionSelected,
    selectedTab,
    setIsDifferentDropOff,
    toggleBookRoundtrip,
    wizardState,
  }) => {
    const { formatText } = useLocalization();
    const {
      carWizardState,
      carWizardState: { config: carConfig },
      carWizardState: {
        config: { gtConfig: gtConfig },
      },
    } = wizardState;
    const includeGT = carConfig.includeGT;
    const actionForm =
      selectedTab === carSubLOBs.rental
        ? carConfig.isCarTrawler
          ? carConfig.form.action.replace("{locale}", context.locale.substr(0, 2))
          : carConfig.form.action
        : gtConfig.form.action;

    const setInputsRefs = (ref: React.RefObject<HTMLInputElement>, secondRef?: React.RefObject<HTMLInputElement>) => {
      carWizardState.wizardInputsArray.push(ref);
      if (secondRef) {
        carWizardState.wizardInputsArray.push(secondRef);
      }
    };

    const getLocError = (isLink: boolean) => {
      if (!isLink) {
        return carWizardState.moreThanOneError()
          ? carConfig.form.submitButton.locMultipleWarningsToken!
          : carConfig.form.submitButton.locWarningToken!;
      }

      return carWizardState.moreThanOneError()
        ? carConfig.form.submitButton.locMultipleWarningsLinkToken
        : carConfig.form.submitButton.locWarningLinkToken;
    };

    const onTabSelect = (clickedTab: carSubLOBs) => {
      onTabOptionSelected(clickedTab);
    };

    return (
      <form
        noValidate={true}
        action={actionForm}
        autoComplete="off"
        className="WizardCarPWA"
        id={carConfig.elementId}
        data-fm={flexComponent.fmId}
        data-fm-title-id={flexComponent.fmTitleId}
        data-testid="wizard"
        onSubmit={carWizardState.submit}
      >
        <LobTitle lobState={carWizardState} />
        <LobSubtitle lobState={carWizardState} />
        {includeGT ? (
          <>
            <UitkExperimentalButtonTabs
              className="all-t-margin-three"
              selectedTab={carWizardState.subLOBState}
              tabsType={UitkTabsType.NATURAL}
              onTabSelect={onTabSelect}
              tabAnchorType={UitkTabAnchorType.BUTTON}
            >
              <UitkTab
                name={carSubLOBs.rental}
                displayName={formatText(locKeys.carTabTitle)}
                id="Rental-cars-transportation"
                targetURI="carsForm"
              >
                {carWizardState.subLOBState === carSubLOBs.rental && (
                  <CarsFormView
                    setInputsRefs={setInputsRefs}
                    carWizardState={carWizardState}
                    carConfig={carConfig}
                    onDriverAgeInRange={onDriverAgeInRange}
                    onDifferentDropOffSelected={onDifferentDropOffSelected}
                    setIsDifferentDropOff={setIsDifferentDropOff}
                    isDriverAgeInRange={isDriverAgeInRange}
                    isDiffDropOff={isDiffDropOff}
                    getLocError={getLocError}
                    onAARPChange={onAARPChange}
                    isAARPChecked={isAARPChecked}
                  />
                )}
              </UitkTab>
              <UitkTab
                name={carSubLOBs.groundTransportation}
                displayName={formatText(locKeys.gtTabTitle)}
                id="Airport-transportation"
                targetURI="gtForm"
              >
                {carWizardState.subLOBState === carSubLOBs.groundTransportation && (
                  <GroundTransportPWAView
                    setInputsRefs={setInputsRefs}
                    carWizardState={carWizardState}
                    toggleBookRoundtrip={toggleBookRoundtrip}
                    getLocError={getLocError}
                  />
                )}
              </UitkTab>
            </UitkExperimentalButtonTabs>
          </>
        ) : (
          <>
            <CarsFormView
              setInputsRefs={setInputsRefs}
              carWizardState={carWizardState}
              carConfig={carConfig}
              onDriverAgeInRange={onDriverAgeInRange}
              onDifferentDropOffSelected={onDifferentDropOffSelected}
              setIsDifferentDropOff={setIsDifferentDropOff}
              isDriverAgeInRange={isDriverAgeInRange}
              isDiffDropOff={isDiffDropOff}
              getLocError={getLocError}
              onAARPChange={onAARPChange}
              isAARPChecked={isAARPChecked}
            />
          </>
        )}
      </form>
    );
  }
);

export default WizardCarPWAView;
